module.exports = __webpack_public_path__ + "img/casting0102_resize.560bd05a.jpg";